<div class="row justify-content-center">
  <!-- Left Sidebar -->

  <div class="col-lg-9 content-area" style="top:45px">
    <div class="page-card">
      <div>

        <h2 id="quickreference" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'quickreference'">Quick Reference</h2>

        <p class="f-s-14">
          This information is provided to describe the routines you need to follow to record, organize and manage your
          financial transactions efficiently. It must be read in conjunction with the detailed information provided in
          the user guide.
        </p>

        <ol class="sub-feature-list">
          <li>Creating password and Logging in</li>
          <li>Creating New Charity records or Opening Existing Charity records</li>
          <li>Add or Select the Financial Period</li>
          <li>Data Input &amp; Preparation (Trial Balance, Adjustments, Notes &amp; Supporting Information)</li>
          <li>Submission &amp; Approval</li>
          <li>Financial Statement Generation</li>
        </ol>
      </div>

      <div>

        <h2 id="creatingpasswordandLoggingin" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'creatingpasswordandLoggingin'">
          Creating Password and Logging In
        </h2>

        <p class="f-s-14">
          Create the password using the link provided in the email that you received upon successfully placing the order.
          The link is valid for 48 hours.
        </p>

        <p class="f-s-14">
          Once you have successfully created the password for Andica Charity Accounts Software, you can log into the
          application using your email ID and the password you created.
        </p>


      </div>

      <div>

        <h2 id="creatingNewCharityrecordsorOpeningExistingCharityrecords" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'creatingNewCharityrecordsorOpeningExistingCharityrecords'">
          Creating New Charity or Opening Existing Charity Records
        </h2>

        <p class="f-s-14">
          Once you have logged into the software, create a new charity or open the existing charity.
        </p>

      </div>

      <div>

        <h2 id="addorSelecttheFinancialPeriod" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'addorSelecttheFinancialPeriod'">
          Add or Select the Financial Period
        </h2>

        <p class="f-s-14">
          Once you create a new charity or select the existing charity, create or select financial period for the same.
        </p>

      </div>

      <div>

        <h2 id="dataInputandPreparationTrialBalanceAdjustmentsNotesSupportingInformation" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'dataInputandPreparationTrialBalanceAdjustmentsNotesSupportingInformation'">
          Data Input &amp; Preparation (Trial Balance, Adjustments, Notes &amp; Supporting Information)
        </h2>

        <p class="f-s-14">
          Fill or import the file to fill all the necessary forms.
        </p>

      </div>

      <div>

        <h2 id="SubmissionandApproval" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'SubmissionandApproval'">
          Submission &amp; Approval
        </h2>

        <p class="f-s-14">
          Once all the forms are filled, submit for review and approval.
          Once its finalised then no changes can be done.
        </p>

      </div>

      <div>

        <h2 id="FinancialStatementGeneration" class="f-s-20 f-w-700 m-t-24" [class.active-heading]="selectedSection === 'FinancialStatementGeneration'">
          Financial Statement Generation
        </h2>

        <p class="f-s-14">
          Once the selected accounting period is finalised, the report can be submitted directly to
        </p>
        <p class="f-s-14">
          Companies House & can extract the file and upload it to the Charity Commission portal.
        </p>

      </div>
    </div>
    </div>
    <!-- Right Sidebar -->
    <div class="col-lg-3">
      <div class="on-page-sidebar">
        <p class="sidebar-title">On this page</p>

      

            <ul class="submenu-level-2">

              <li [class.active]="selectedSection === 'quickreference'"
                  (click)="changeSection('quickreference')">

                Quick Reference

              </li>

              <li [class.active]="selectedSection === 'creatingpasswordandLoggingin'"
                  (click)="changeSection('creatingpasswordandLoggingin')">

                Creating Password and Logging In

              </li>

              <li [class.active]="selectedSection === 'creatingNewCharityrecordsorOpeningExistingCharityrecords'"
                  (click)="changeSection('creatingNewCharityrecordsorOpeningExistingCharityrecords')">

                Creating New Charity Records

              </li>

              <li [class.active]="selectedSection === 'addorSelecttheFinancialPeriod'"
                  (click)="changeSection('addorSelecttheFinancialPeriod')">

                Add or Select Financial Period

              </li>

              <li [class.active]="selectedSection === 'dataInputandPreparationTrialBalanceAdjustmentsNotesSupportingInformation'"
                  (click)="changeSection('dataInputandPreparationTrialBalanceAdjustmentsNotesSupportingInformation')">

                Data Input & Preparation

              </li>

              <li [class.active]="selectedSection === 'SubmissionandApproval'"
                  (click)="changeSection('SubmissionandApproval')">

                Submission & Approval

              </li>

              <li [class.active]="selectedSection === 'FinancialStatementGeneration'"
                  (click)="changeSection('FinancialStatementGeneration')">

                Financial Statement Generation

              </li>

            </ul>
      </div>
    </div>
  </div>




